module.exports = __webpack_public_path__ + "static/img/MV9.a3074fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/MV9.jpg
// module id = okvn
// module chunks = 0